import { render, staticRenderFns } from "./editDevice.vue?vue&type=template&id=19c48f04&scoped=true&"
import script from "./editDevice.vue?vue&type=script&lang=js&"
export * from "./editDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c48f04",
  null
  
)

export default component.exports